module.exports = __webpack_public_path__ + "images/img-1xju2uq.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/ru/9.png
// module id = 2358
// module chunks = 0